<template>
  <div class="nx-seo-inheritable-editor mt-4" v-if="value">

    <template v-for="textField in textFields">
      <nx-seo-inheritable-text-field
        :key="textField"
        :label="$t(`message.seo.${textField}`)"
        :name="textField"
        :disabled="disabled"
        :value="value[textField]"
        :counter="textFieldCounter(textField)"
        v-if="!isHiddenField(textField)"
      ></nx-seo-inheritable-text-field>
    </template>

    <nx-seo-array-field
      :label="$t('message.seo.keywords')"
      name="keywords"
      :value="value.keywords"
      :disabled="disabled"
      @input="updateField"
      v-if="!isHiddenField('keywords')"
    ></nx-seo-array-field>

    <nx-seo-robots-field
      :label="$t('message.seo.robots')"
      name="robots"
      :value="value.robots"
      :disabled="disabled"
      @input="updateField"
      v-if="!isHiddenField('robots')"
    ></nx-seo-robots-field>

    <nx-seo-metas-field
      :label="$t('message.seo.metas.name')"
      name="ownMetas"
      :value="value.ownMetas"
      :disabled="disabled"
      :inherited-metas="value.inheritedMetas"
      :in-taxonomy="false"
      v-if="!isHiddenField('ownMetas')"
      @input="updateField">
    </nx-seo-metas-field>
  </div>
</template>

<script>
import Form from '@/modules/form/Form';
import { cloneDeep, isObject } from 'lodash';
import NxSeoInheritableTextField from '@/modules/seo/components/InheritableTextField';
import NxSeoArrayField from '@/modules/seo/components/ArrayField';
import NxSeoRobotsField from '@/modules/seo/components/RobotsField';
import NxSeoMetasField from '@/modules/seo/components/MetasField';

export default {
  name: 'nx-seo-editor',
  extends: Form,
  components: {
    NxSeoMetasField,
    NxSeoRobotsField,
    NxSeoArrayField,
    NxSeoInheritableTextField,
  },
  props: {
    value: {
      type: Object,
    },
    textFields: {
      type: Array,
      default: () => ([
        'title',
        'description',
        'canonicalUrl',
      ]),
    },
    textFieldsCounter: {
      type: Object,
      default: () => ({}),
    },
    hiddenFields: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    updateField(field, value) {
      const emitValue = cloneDeep(this.value);
      if (isObject(emitValue[field])
        && 'value' in emitValue[field]) {
        emitValue[field].value = value;
      } else {
        emitValue[field] = value;
      }
      this.$emit('input', emitValue);
    },
    isHiddenField(field) {
      return this.hiddenFields.includes(field);
    },
    textFieldCounter(textField) {
      if (Object.keys(this.textFieldsCounter).includes(textField)) {
        return this.textFieldsCounter[textField];
      }
      return null;
    },
  },
};
</script>
